class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
    
    // Close on click outside
    document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.close();
    });
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  onFocus() {
      const searchTerm = this.input.value.trim();
      if (!searchTerm.length) return;
      
       if (this.getAttribute('results') === 'true') {
        this.open();
      } else {
        this.getSearchResults(searchTerm);
      }
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    
    // Fetch suggestions from Shopify's Predictive Search API
    fetch(`/search/suggest.json?q=${encodeURIComponent(searchTerm)}&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.statusText);
          this.close();
          throw error;
        }

        return response.json();
      })
      .then((data) => {
        const products = data.resources.results.products;
        if (products.length > 0) {
            this.renderSearchResults(products);
        } else {
            this.close();
        }
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  renderSearchResults(products) {
    this.predictiveSearchResults.innerHTML = '';
    
    const resultsList = document.createElement('div');
    resultsList.classList.add('bg-white', 'dark:bg-gray-900', 'shadow-xl', 'rounded-xl', 'overflow-hidden', 'border', 'border-gray-100', 'dark:border-white/10');
    
    const title = document.createElement('div');
    title.classList.add('px-4', 'py-3', 'bg-gray-50', 'dark:bg-white/5', 'text-xs', 'font-bold', 'uppercase', 'tracking-widest', 'text-gray-500', 'border-b', 'border-gray-100', 'dark:border-white/10');
    title.textContent = 'Products';
    resultsList.appendChild(title);

    products.forEach(product => {
        const item = document.createElement('a');
        item.href = product.url;
        item.classList.add('flex', 'items-center', 'gap-4', 'p-4', 'hover:bg-gray-50', 'dark:hover:bg-white/5', 'transition-colors', 'border-b', 'border-gray-100', 'dark:border-white/10', 'last:border-0');
        
        // Image
        if(product.image) {
             const imgContainer = document.createElement('div');
             imgContainer.classList.add('w-12', 'h-12', 'shrink-0', 'rounded-md', 'overflow-hidden', 'bg-gray-100', 'dark:bg-white/5');
             const img = document.createElement('img');
             img.src = product.image;
             img.classList.add('w-full', 'h-full', 'object-cover');
             img.alt = product.title;
             imgContainer.appendChild(img);
             item.appendChild(imgContainer);
        }

        // Info
        const info = document.createElement('div');
        const titleEl = document.createElement('h3');
        titleEl.classList.add('text-sm', 'font-bold', 'text-gray-900', 'dark:text-white', 'hover:text-primary', 'transition-colors');
        titleEl.textContent = product.title;
        
        const priceEl = document.createElement('div');
        priceEl.classList.add('text-xs', 'text-gray-500', 'mt-1');
        priceEl.textContent = '₹' + (parseFloat(product.price)).toFixed(2); // Simple formatting, ideally use money formatter
        
        info.appendChild(titleEl);
        info.appendChild(priceEl);
        item.appendChild(info);

        resultsList.appendChild(item);
    });

    // View all link
    const viewAll = document.createElement('a');
    viewAll.href = `/search?q=${encodeURIComponent(this.input.value)}`;
    viewAll.classList.add('block', 'text-center', 'py-3', 'text-sm', 'font-bold', 'text-primary', 'hover:text-gray-900', 'bg-gray-50', 'dark:bg-white/5', 'hover:underline');
    viewAll.textContent = `Search for "${this.input.value}"`;
    resultsList.appendChild(viewAll);

    this.predictiveSearchResults.appendChild(resultsList);
    this.open();
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
    this.setAttribute('open', true);
    this.setAttribute('results', true);
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
    this.removeAttribute('open');
    this.setAttribute('results', false);
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
